import { useEffect, useRef, useState } from 'react'
import useInnovaAxios from './useInnovaAxios'

function useOilPrices() {
  const _isMounted = useRef(false)
  const isLoading = useRef(false)
  const [loading, setLoading] = useState(false)
  const brentCrudePriceRef = useRef(null)
  const wtiPriceRef = useRef(null)
  const naturalGasPriceRef = useRef(null)
  const rigCountRef = useRef(null)

  const getOilPrices = useInnovaAxios({
    url: '/oilPrices/getOilPrices',
  })

  const getRigCounts = useInnovaAxios({
    url: '/oilPrices/getRigCount',
  })

  useEffect(() => {
    _isMounted.current = true

    return () => {
      _isMounted.current = false
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchOilPrices = async () => {
    if (isLoading.current) return
    isLoading.current = true
    if (_isMounted.current) setLoading(true)

    const respBrentCrude = await getOilPrices({ code: 'BRENT_CRUDE_USD' })

    const respWti = await getOilPrices({ code: 'WTI_USD' })

    const respNaturalGas = await getOilPrices({ code: 'NATURAL_GAS_USD' })

    const respRigCount = await getRigCounts()

    if (!_isMounted.current) return

    if (!respBrentCrude?.error) {
      brentCrudePriceRef.current = respBrentCrude.data
    }

    if (!respWti?.error) {
      wtiPriceRef.current = respWti.data
    }

    if (!respNaturalGas?.error) {
      naturalGasPriceRef.current = respNaturalGas.data
    }

    if (!respRigCount?.error) {
      rigCountRef.current = respRigCount.data
    }

    setLoading(false)
    isLoading.current = false
  }

  const getBrentCrudePrice = () => {
    return brentCrudePriceRef.current
  }

  const getWtiPrice = () => {
    return wtiPriceRef.current
  }

  const getNaturalGasPrice = () => {
    return naturalGasPriceRef.current
  }

  const getRigCount = () => {
    return rigCountRef.current
  }

  return {
    fetchOilPrices,
    loading,
    getBrentCrudePrice,
    getWtiPrice,
    getNaturalGasPrice,
    getRigCount,
  }
}

export default useOilPrices
